/**
 * What we call the things the service only numbers.
 *
 * A task plan has no human label on the wire - `TaskPlanSummary` carries a ULID
 * and an `internal_id`, the warehouse-scoped sequential number. The ULID is not
 * something a manager reads out, so a plan is drawn from the number.
 *
 * One function rather than a template literal at each call site, because the
 * prefix is the part that will be argued about. When "PLAN-3120" turns out to be
 * "Wave 3120" or a name the service starts carrying, this is the file that
 * changes and every screen follows.
 *
 * Shared rather than route-private for exactly that reason: Outbound draws plan
 * cards and the Engine Room draws a plan table, and the two naming the same plan
 * differently is the failure this file exists to prevent.
 */

/**
 * A task plan's display name, from its warehouse-scoped id.
 *
 * Takes the id rather than the plan so it can be called from the wire mapper,
 * which is upstream of anything shaped like a plan.
 */
export function taskPlanName(internalId: number): string {
  return `PLAN-${internalId}`;
}
